export default __webpack_public_path__ + "static/media/setting_white.d4b60ea6.svg";